import React, { FunctionComponent } from 'react';
import styles from './spinner.module.css';

export interface SpinnerProps {
  colorTop: string;
  colorBottom: string;
}

export const Spinner: FunctionComponent<SpinnerProps> = (props: any) => {
  const { colorBottom, colorTop } = props;

  return (
    <svg className={styles.wrapper}>
      <circle
        className={styles.bottom}
        cx="12"
        cy="12"
        fill="transparent"
        r="10"
        stroke={colorBottom}
        strokeWidth="4"
      ></circle>
      <circle
        className={styles.top}
        cx="12"
        cy="12"
        fill="transparent"
        r="10"
        stroke={colorTop}
        strokeWidth="4"
      ></circle>
    </svg>
  );
};
